import Itemvideo from 'components/3cat/Itemvideo';

export default function ItemvideoFastChannel(props) {
    const { destacats, codiEspectador, routerQuery } = props;
    const destacatDirecte = destacats.filter((item) => item.canals?.[0]?.id?.toLowerCase().includes(routerQuery?.canal))?.[0];
    return (
        <Itemvideo
            directe={true}
            tipus='video'
            versio='vast'
            mostraH1={false}
            autoPlay={true}
            id={routerQuery?.canal}
            imatges={destacatDirecte?.imatges}
            titol={destacatDirecte?.avantitol}
            entradeta={destacatDirecte?.entradeta}
            logo={destacatDirecte?.logos_canals?.find((canal) => canal.main === true)?.id}
            canal={destacatDirecte?.canals?.find((canal) => canal.main === true)?.id}
            canalLogo={destacatDirecte?.logos_canals?.find((canal) => canal.main === true)?.id}
            codiEspectador={codiEspectador}
        />
    );
}
